import { DownloadOutlined } from "@ant-design/icons";
import { Button, Tag } from "antd";
import Delete from "../assets/Delete.jsx";

// Table columns for uploaded documents
export const getDocumentColumns = (handleAction, totalData = 2) => {
  const documentColumns = [
    {
      title: "Document Type",
      dataIndex: "documentType",
      key: "documentType",
    },
    {
      title: "Document Name",
      dataIndex: "documentName",
      key: "documentName",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => <Tag color="orange">{status}</Tag>,
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => {
        return (
          <div className="flex gap-2">
            <button
              type="button"
              onClick={() => handleAction("download", record)}
              className="flex items-center justify-center border-0 bg-transparent cursor-pointer p-1"
            >
              <DownloadOutlined />
            </button>
            {totalData > 1 && (
              <Button
                type="text"
                danger
                icon={<Delete />}
                onClick={() => handleAction("delete", record)}
                className="flex items-center justify-center"
              />
            )}
          </div>
        );
      },
    },
  ];

  return documentColumns;
};
